module.exports = __webpack_public_path__ + "static/img/cover-02.18a387ed.png";